import { useMutation, useQueryClient } from "@tanstack/react-query";
import { postApiCodelistManagementFilesIdActivate } from "Infrastructure/Api/Api";
import { useSnackbar } from "Infrastructure/Providers/SnackbarProvider/SnackbarProvider";
import { CODELIST_FILES_QUERY_KEY } from "../Queries/useCodeListFilesQuery";
import { CODELIST_FILE_VERSIONS_QUERY_KEY } from "../Queries/useCodeListFileVersionsQuery";

export function useActivateVersionMutation() {
	const queryClient = useQueryClient();
	const showSnackbar = useSnackbar();

	return useMutation({
		mutationFn: (id: number) => postApiCodelistManagementFilesIdActivate(id),
		onSuccess: (response) => {
			if (response.status === 200) {
				if (response.data.alreadyActive) {
					showSnackbar("Tato verze je již aktivní", "info");
				} else {
					showSnackbar(
						`Verze ${response.data.activatedVersion} byla aktivována`,
						"success"
					);
				}
				queryClient.invalidateQueries({ queryKey: [CODELIST_FILES_QUERY_KEY] });
				queryClient.invalidateQueries({
					queryKey: [CODELIST_FILE_VERSIONS_QUERY_KEY],
				});
			} else {
				showSnackbar("Chyba při aktivaci verze", "error");
			}
		},
		onError: () => {
			showSnackbar("Chyba při aktivaci verze", "error");
		},
	});
}
